export default __webpack_public_path__ + "static/media/I9648.385fa0e7.jpg";